import { useParams } from 'next/navigation';
import { useThirdPartyHeaderStore } from '@/store/third-party-header';
import { useLayoutSegmentsMatched } from './use-layout-segments-matched';

const NONE_TOP_HEADER_PAGES = [
	'bets',
	'jackpot',
	'widget',
	'intro',
	'wc-promotion',
	'golden-duel',
	'score-challenge',
	'tournament'
];

export const useTopHeaderDisplay = () => {
	const params = useParams();
	const isThirdPartyShowHeader = useThirdPartyHeaderStore(state => state.isThirdPartyShowHeader);
	return (
		!useLayoutSegmentsMatched(NONE_TOP_HEADER_PAGES) && params.matchId === undefined && isThirdPartyShowHeader
	);
};